export const FUNDING_CODES = [
  '07BW20730',
  '07BW21000',
  '07BW21455',
  '07BW21409',
  '03BW21094',
  '03BW20995',
  '04BW20736',
  '04BW20728',
  '04BW20727',
  '03BW20691',
  '03BW20689',
  '03BW20685',
  '03BW20684',
  '04BW20679',
  '04BW20602',
  '04BW20567',
  '03BW20527',
  '04BW20526',
  '04BW20525',
  '04BW20523',
  '04BW20301',
  '04BW20300',
  '03BW20117',
  '01BW21992',
  '01BW21944',
  '01BW21874',
  '01BW21830',
  '01BW21753',
  '01BW21681',
  '01BW21676',
  '01BW21675',
  '13BW200016',
  '09BW200765',
  '09BW200748',
  '09BW200579',
  '09BW200481',
  '09BW200705',
  '09BW200706',
  '09BW200488',
  '09BW200710',
  '09BW200517',
  '09BW200443',
  '01BW21392',
  '01BW21391',
  '01BW20454',
  '01BW21115',
  '01BW21311',
  '01BW20979',
  '01BW21259',
  '01BW21258',
  '01BW21162',
  '01BW21161',
  '01BW21199',
  '01BW20860',
  '01BW21176',
  '11BW200425',
  '12BW200151',
  '12BW200149',
  '11BW200380',
  '11BW200669',
  '12BW200267',
  '09BW200584',
  '09BW200486',
  '01BW21966',
  '03BW20671',
  '12BW200228',
  '09BW200444',
  '09BW200746',
  '09BW200711',
] as const
export type FundingCode = (typeof FUNDING_CODES)[number]

export const MUNICIPALITIES = [
  'Achberg',
  'Achstetten',
  'Aichstetten',
  'Aitrach',
  'Albstadt',
  'Alleshausen',
  'Allmannsweiler',
  'Allmendingen',
  'Alpirsbach',
  'Altheim',
  'Altheim (Alb)',
  'Altshausen',
  'Amstetten',
  'Amtzell',
  'Argenbühl',
  'Asselfingen',
  'Attenweiler',
  'Aulendorf',
  'Bad Buchau',
  'Bad Rippoldsau-Schapbach',
  'Bad Saulgau',
  'Bad Schussenried',
  'Bad Urach',
  'Bad Waldsee',
  'Bad Wurzach',
  'Baienfurt',
  'Baiersbronn',
  'Baindt',
  'Balingen',
  'Ballendorf',
  'Balzheim',
  'Beimerstetten',
  'Berg',
  'Bergatreute',
  'Berghülen',
  'Berkheim',
  'Bermatingen',
  'Bernstadt',
  'Betzenweiler',
  'Beuron',
  'Biberach an der Riß',
  'Bingen',
  'Bisingen',
  'Bitz',
  'Blaubeuren',
  'Blaustein',
  'Bodnegg',
  'Boms',
  'Börslingen',
  'Breitingen',
  'Burgrieden',
  'Burladingen',
  'Daisendorf',
  'Dautmergen',
  'Deggenhausertal',
  'Dettingen an der Erms',
  'Dettingen an der Iller',
  'Dietenheim',
  'Dormettingen',
  'Dornstadt',
  'Dornstetten',
  'Dotternhausen',
  'Dürmentingen',
  'Dürnau',
  'Ebenweiler',
  'Eberhardzell',
  'Ebersbach-Musbach',
  'Ehingen (Donau)',
  'Eichstegen',
  'Emeringen',
  'Emerkingen',
  'Empfingen',
  'Engstingen',
  'Eningen unter Achalm',
  'Erbach',
  'Eriskirch',
  'Erlenmoos',
  'Erolzheim',
  'Ertingen',
  'Eutingen im Gäu',
  'Fleischwangen',
  'Freudenstadt',
  'Frickingen',
  'Friedrichshafen',
  'Fronreute',
  'Gammertingen',
  'Geislingen',
  'Glatten',
  'Gomadingen',
  'Grabenstetten',
  'Grafenberg',
  'Griesingen',
  'Grömbach',
  'Grosselfingen',
  'Grundsheim',
  'Grünkraut',
  'Guggenhausen',
  'Gutenzell-Hürbel',
  'Gutsbezirk Münsingen(gemeindefrei)',
  'Hagnau am Bodensee',
  'Haigerloch',
  'Hausen am Bussen',
  'Hausen am Tann',
  'Hayingen',
  'Hechingen',
  'Heiligenberg',
  'Herbertingen',
  'Herdwangen-Schönach',
  'Heroldstatt',
  'Hettingen',
  'Hochdorf',
  'Hohenstein',
  'Hohentengen',
  'Holzkirch',
  'Horb am Neckar',
  'Horgenzell',
  'Hoßkirch',
  'Hülben',
  'Hüttisheim',
  'Illerkirchberg',
  'Illerrieden',
  'Illmensee',
  'Immenstaad am Bodensee',
  'Ingoldingen',
  'Inzigkofen',
  'Isny im Allgäu',
  'Jungingen',
  'Kanzach',
  'Kirchberg an der Iller',
  'Kirchdorf an der Iller',
  'Kißlegg',
  'Königseggwald',
  'Krauchenwies',
  'Kressbronn am Bodensee',
  'Laichingen',
  'Langenargen',
  'Langenau',
  'Langenenslingen',
  'Laupheim',
  'Lauterach',
  'Leibertingen',
  'Leutkirch im Allgäu',
  'Lichtenstein',
  'Lonsee',
  'Loßburg',
  'Markdorf',
  'Maselheim',
  'Meckenbeuren',
  'Meersburg',
  'Mehrstetten',
  'Mengen',
  'Merklingen',
  'Meßkirch',
  'Meßstetten',
  'Metzingen',
  'Mietingen',
  'Mittelbiberach',
  'Moosburg',
  'Munderkingen',
  'Münsingen',
  'Neenstetten',
  'Nellingen',
  'Nerenstetten',
  'Neufra',
  'Neukirch',
  'Nusplingen',
  'Oberdischingen',
  'Obermarchtal',
  'Obernheim',
  'Oberstadion',
  'Oberteuringen',
  'Ochsenhausen',
  'Oggelshausen',
  'Öllingen',
  'Öpfingen',
  'Ostrach',
  'Owingen',
  'Pfalzgrafenweiler',
  'Pfronstetten',
  'Pfullendorf',
  'Pfullingen',
  'Pliezhausen',
  'Rammingen',
  'Rangendingen',
  'Ratshausen',
  'Ravensburg',
  'Rechtenstein',
  'Reutlingen',
  'Riederich',
  'Riedhausen',
  'Riedlingen',
  'Römerstein',
  'Rosenfeld',
  'Rot an der Rot',
  'Rottenacker',
  'Salem',
  'Sauldorf',
  'Scheer',
  'Schelklingen',
  'Schemmerhofen',
  'Schlier',
  'Schnürpflingen',
  'Schömberg',
  'Schopfloch',
  'Schwendi',
  'Schwenningen',
  'Seekirch',
  'Seewald',
  'Setzingen',
  'Sigmaringen',
  'Sigmaringendorf',
  'Sipplingen',
  'Sonnenbühl',
  'Staig',
  'Steinhausen an der Rottum',
  'Stetten',
  'Stetten am kalten Markt',
  'St. Johann',
  'Straßberg',
  'Tannheim',
  'Tettnang',
  'Tiefenbach',
  'Trochtelfingen',
  'Überlingen',
  'Uhldingen-Mühlhofen',
  'Ummendorf',
  'Unlingen',
  'Untermarchtal',
  'Unterstadion',
  'Unterwachingen',
  'Unterwaldhausen',
  'Uttenweiler',
  'Veringenstadt',
  'Vogt',
  'Wain',
  'Wald',
  'Waldachtal',
  'Waldburg',
  'Walddorfhäslach',
  'Wangen im Allgäu',
  'Wannweil',
  'Warthausen',
  'Weidenstetten',
  'Weilen unter den Rinnen',
  'Weingarten',
  'Westerheim',
  'Westerstetten',
  'Wilhelmsdorf',
  'Winterlingen',
  'Wolfegg',
  'Wolpertswende',
  'Wörnersberg',
  'Zimmern unter der Burg',
  'Zwiefalten',
] as const
export type Municipality = (typeof MUNICIPALITIES)[number]
